const devilNote = require('./devil')

module.exports = [
  'Вы несёте на своих плечах безопасность Врат Балдура и приветствуете этот груз ответственности',
]
